import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { DetailEksisPage } from '../detail-eksis/detail-eksis.page';
import { BuatPostingPage } from '../buat-posting/buat-posting.page';
import { ActionSheetController } from '@ionic/angular';
import{ApiService} from '../../services/api.service';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import {Router} from "@angular/router";

@Component({
  selector: 'app-eksis',
  templateUrl: './eksis.page.html',
  styleUrls: ['./eksis.page.scss'],
})
export class EksisPage implements OnInit {

	eksis: string = 'semua';

  constructor(
    private modalCtrl:ModalController, 
    private navCtrl:NavController, 
    private actionSheetController: ActionSheetController, 
    private api:ApiService,
    private camera:Camera,
    private router:Router
    ) { }

  ngOnInit() {
      
  }
  ionViewDidEnter(){      
      this.cekLogin();
      this.getDataAll();
      this.getDataMine();
  }

  userData:any={};
  isLoggedIn:boolean=false;
  cekLogin()
  {
    this.api.data('user/me','get','').subscribe(data=>{
        this.userData=data;
        this.isLoggedIn=true;
      },error=>{
          
      })
  }

  keyApp:any=localStorage.getItem('keyApp');
  pageAll:number=1;
  dataAll:any=[];
  loadingAll:boolean;
  getDataAll()
  {
      this.loadingAll=true;
      this.api.data('eksis/all?key_app='+this.keyApp+'&page='+this.pageAll,'get','').subscribe(data=>{
          this.loadingAll=false;
          this.parseData('all',data);
          this.pageAll=this.pageAll+1;
      })
  }

  dataMine:any=[];
  pageMine:number=1;
  loadingMine:boolean;
  getDataMine()
  {
      this.loadingMine=true;
      this.api.data('eksis/mine?key_app='+this.keyApp+'&page='+this.pageMine,'get','').subscribe(data=>{
          this.loadingMine=false;
          this.parseData('mine',data);
      })
  }
  parseData(type,data)
  {
      for(var i=0; i<data.length; i++)
      {
          if(type=='all')
          this.dataAll.push(data[i]);
          else
          this.dataMine.push(data[i]);
      }
  }
  async modalEksis(data) {
    const modal = await this.modalCtrl.create({
      component: DetailEksisPage,
      componentProps: {
        posting:data
      }
    });
    return await modal.present();
  }

   async optionEksis() {
    const actionSheet = await this.actionSheetController.create({
      header: 'Judul Eksis',
      buttons: [{
        text: 'Hapus',
        role: 'destructive',
        icon: 'trash',
        handler: () => {
          console.log('Delete clicked');
        }
      },{
        text: 'Edit',
        icon: 'create',
        handler: () => {
          console.log('Edit clicked');
        }
      }, {
        text: 'Batal',
        icon: 'close',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }

  //camera
 

  getCamera(mode)
  {       
      const options: CameraOptions = {
        quality: 80,
        allowEdit:true,
        targetWidth:500,
        targetHeight:500,
        sourceType:mode,
        correctOrientation: true,
        destinationType: this.camera.DestinationType.DATA_URL,
        encodingType: this.camera.EncodingType.JPEG
      };
      this.camera.getPicture(options).then((imageData) => {     
        let base64Image = 'data:image/jpeg;base64,' + imageData;
        this.showModalPosting(base64Image);
      }, (err) => {
          console.log(err);
      });
     
  }
  async showModalPosting(data) {
    const modal = await this.modalCtrl.create({
      component: BuatPostingPage,
      componentProps: {
        imageData:data
      }
    });
    return await modal.present();
  }

  share(type)
  {
      if(type=='instagram')
      {
          return;
      }
  }

}
